// Invoice number format tokens:
//   {CLIENT} -> client's prefix
//   {YYYY}   -> 4-digit year      {YY} -> 2-digit year
//   {MM}     -> 2-digit month
//   {#} {##} {###} {####} -> sequence number zero-padded to that width
// Anything else in the string is a literal.

export interface InvoiceNumberParts {
  prefix: string | null
  // ISO date the invoice is issued (year/month come from here)
  issuedDate: string // 'YYYY-MM-DD'
  seq: number
}

export function formatInvoiceNumber(format: string, parts: InvoiceNumberParts): string {
  const { prefix, issuedDate, seq } = parts
  const [yyyy, mm] = issuedDate.split('-')
  const yy = yyyy.slice(2)

  let out = format
  // Sequence tokens first (width-dependent).
  out = out.replace(/\{(#{1,4})\}/g, (_m, hashes: string) =>
    String(seq).padStart(hashes.length, '0'),
  )
  out = out
    .replace(/\{CLIENT\}/g, prefix ?? '')
    .replace(/\{YYYY\}/g, yyyy)
    .replace(/\{YY\}/g, yy)
    .replace(/\{MM\}/g, mm)
  return out
}
